<template>
  <div id="create-collector" class="d-flex justify-center align-center fill-height">
    <v-card class="configure-security-wrapper add-edit-wrapper ma-auto" width="722">
      <v-toolbar color="primary" dark class="shadow-none">
        <v-card-title
          class="headline px-0"
        >
          Configure Security
        </v-card-title>
      </v-toolbar>
      <v-card-text class="dark--text px-0">
        <v-simple-table
          class="light-table configure-security-table"
          hide-default-footer
        >
          <tbody>
            <tr>
              <AWSConfigureForm
                ref="awsForm"
                :aws="configureForm.aws"
                @setData="setData"
              />
            </tr>
            <tr>
              <AzureConfigureForm
                ref="azureForm"
                :azure="configureForm.azure"
                @setData="setData"
              />
            </tr>
            <tr>
              <AzureDataLakeForm
                ref="azureLakeForm"
                :azureLake="configureForm.azureLake"
                @setData="setData"
              />
            </tr>
            <tr>
              <AzureBlobConfigureForm
                ref="azureBlobForm"
                :azureBlob="configureForm.azureBlob"
                @setData="setData"
              />
            </tr>
            <tr>
              <GoogleConfigureForm
                ref="googleForm"
                :google="configureForm.google"
                :googleJson="googleJson"
                @onFileChange="onFileChange"
              />
            </tr>
            <tr>
              <DropBoxConfigureForm
                ref="dropBoxForm"
                :dropBox="configureForm.dropBox"
                @setData="setData"
              />
            </tr>
            <tr>
              <BoxConfigureForm
                ref="boxForm"
                :box="configureForm.box"
                @setData="setData"
              />
            </tr>
            <tr>
              <SlackConfigureForm
                ref="slackForm"
                :slack="configureForm.slack"
                @setData="setData"
              />
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions class="d-flex flex-column px-0 pt-14px pb-0">
        <v-spacer></v-spacer>
        <v-btn class="save-btn mb-16px" text @click="saveCollector">
          Save
        </v-btn>
        <v-btn class="cancel-btn" text @click="$emit('resetDialogConfigureSecurityItem')">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AWSConfigureForm from './AWSConfigureForm'
import AzureConfigureForm from './AzureConfigureForm'
import AzureDataLakeForm from './AzureDataLakeForm'
import AzureBlobConfigureForm from './AzureBlobConfigureForm'
import GoogleConfigureForm from './GoogleConfigureForm'
import DropBoxConfigureForm from './DropBoxConfigureForm'
import BoxConfigureForm from './BoxConfigureForm'
import SlackConfigureForm from './SlackConfigureForm'
import _ from 'underscore'

export default {
  name: 'ConfigureSecurityEditor',
  components: {
    AWSConfigureForm,
    AzureConfigureForm,
    AzureDataLakeForm,
    AzureBlobConfigureForm,
    GoogleConfigureForm,
    DropBoxConfigureForm,
    BoxConfigureForm,
    SlackConfigureForm
  },
  props: ['id'],
  data () {
    return {
      configureForm: {
        aws: {
          enabled: false,
          valid: false,
          dirty: false,
          data: {}
        },
        azure: {
          enabled: false,
          valid: false,
          dirty: false,
          data: {}
        },
        azureLake: {
          enabled: false,
          valid: false,
          dirty: false,
          data: {}
        },
        azureBlob: {
          enabled: false,
          valid: false,
          dirty: false,
          data: {}
        },
        google: {
          enabled: false,
          valid: false,
          dirty: false,
          data: {}
        },
        dropBox: {
          enabled: false,
          valid: false,
          dirty: false,
          data: {}
        },
        box: {
          enabled: false,
          valid: false,
          dirty: false,
          data: {}
        },
        slack: {
          enabled: false,
          valid: false,
          dirty: false,
          data: {}
        }
      },
      rules: {
        required: v => !!v || 'Required.'
      },
      collector: {},
      originalCollector: {},
      googleJson: null
    }
  },
  created () {
    this.loadCollector()
  },
  computed: {
    ...mapGetters(['collectors', 'license'])
  },
  methods: {
    loadCollector () {
      const collector = this.collectors.find(item => item.entity_id === this.id)
      if (!collector) {
        this.$router.push('/utilities')
      } else {
        this.originalCollector = JSON.parse(JSON.stringify(collector))
        if (!this.collector || this.collector.name !== collector.name) {
          this.name = collector.name
        }

        this.collector = collector
        if (this.collector.configure_security) {
          Object.keys(this.collector.configure_security).forEach(key => {
            if (this.collector.configure_security[key]) {
              this.configureForm[key].enabled = true
              if (key === 'google') {
                this.googleJson = this.sortJsonData(this.collector.configure_security.google)
              } else {
                this.configureForm[key].data = this.collector.configure_security[key]
              }
            }
          })
        }
      }
    },
    sendConnectionCommand (providers, data) {
      providers.map((provider) => {
        const connectionArr = []
        let key
        for (key in data) {
          if (data.hasOwnProperty(key)) {
            connectionArr.push(key + '=' + data[key])
          }
        }
        const connectionStr = connectionArr.join(',')

        const command = {
          collector_id: this.collector.entity_id,
          organization_id: this.collector.organization_id,
          status: 'pending',
          type: 'ADD_CLOUD_PROVIDER',
          data: [
            {
              key: 'type',
              value: provider
            },
            {
              key: 'connection',
              value: connectionStr
            }
          ]
        }
        this.$store.dispatch('postCommand', command)
      })
    },
    awsS3ConnectionCommand (data) {
      let connectionString = []
      Object.keys(data).forEach(key => {
        connectionString.push(key + '=' + data[key])
      })
      connectionString = connectionString.join(',')
      const command = {
        collector_id: this.collector.entity_id,
        organization_id: this.collector.organization_id,
        status: 'pending',
        type: 'ADD_CLOUD_PROVIDER',
        data: [
          {
            key: 'provider',
            value: 's3'
          }, {
            key: 'connection',
            value: connectionString
          }
        ]
      }
      this.$store.dispatch('postCommand', command)
    },
    azureConnectionCommand (data, provider) {
      let connectionString = []
      Object.keys(data).forEach(key => {
        connectionString.push(key + '=' + data[key])
      })
      connectionString = connectionString.join(';')
      connectionString = 'connection_string=' + connectionString
      const command = {
        collector_id: this.collector.entity_id,
        organization_id: this.collector.organization_id,
        status: 'pending',
        type: 'ADD_CLOUD_PROVIDER',
        data: [
          {
            key: 'provider',
            value: provider
          },
          {
            key: 'connection',
            value: connectionString
          }
        ]
      }
      this.$store.dispatch('postCommand', command)
    },
    slackConnectionCommand (data) {
      const command = {
        collector_id: this.collector.entity_id,
        organization_id: this.collector.organization_id,
        status: 'pending',
        type: 'DISCOVER',
        data: [
          {
            key: 'provider',
            value: 'slack'
          },
          {
            key: 'connection',
            value: 'access_token=' + data.access_token
          }
        ]
      }
      this.$store.dispatch('postCommand', command)
    },
    async saveCollector () {
      for (const key of Object.keys(this.configureForm)) {
        if (this.configureForm[key].enabled) {
          await this.$refs[key + 'Form'].$refs[key + 'Form'].validate()
          if (key === 'google') {
            if (!this.configureForm.google.data || !this.googleJson) {
              return
            }
            if (!this.configureForm[key].valid) return
          } else {
            if (!this.configureForm[key].valid) return
          }
        }
      }

      const configureSecurity = {}
      for (const key of Object.keys(this.configureForm)) {
        if (this.configureForm[key].enabled) {
          if (key === 'google') {
            configureSecurity[key] = this.googleJson
          } else {
            configureSecurity[key] = this.configureForm[key].data
          }
          if (this.configureForm[key].dirty) {
            switch (key) {
              case 'aws':
                this.awsS3ConnectionCommand(this.configureForm.aws.data)
                break
              case 'azure':
                this.sendConnectionCommand(['microsoft'], this.configureForm.azure.data)
                break
              case 'azureLake':
                this.azureConnectionCommand(this.configureForm.azureLake.data, 'azuredatalake')
                break
              case 'azureBlob':
                this.azureConnectionCommand(this.configureForm.azureBlob.data, 'azureblob')
                break
              case 'google':
                this.sendConnectionCommand(['google'], this.googleJson)
                break
              case 'dropBox':
                this.sendConnectionCommand(['dropbox'], this.configureForm.dropBox.data)
                break
              case 'box':
                this.sendConnectionCommand(['box'], this.configureForm.box.data)
                break
              case 'slack':
                this.slackConnectionCommand(this.configureForm.slack.data)
                break
            }
          }
        } else {
          delete configureSecurity[key]
        }
      }

      this.collector.configure_security = configureSecurity
      this.$store.dispatch('saveCollector', this.collector)
      this.$emit('resetDialogConfigureSecurityItem')
    },
    onFileChange (file) {
      if (!file) {
        this.googleJson = null
        return
      }
      this.readFile(file)

      if (!_.isEqual(this.originalCollector.configure_security?.google, this.googleJson)) {
        this.configureForm.google.dirty = true
      } else {
        this.configureForm.google.dirty = false
      }
    },
    readFile (file) {
      const that = this
      const reader = new FileReader()
      reader.onload = e => {
        const jsonData = Object.assign({}, JSON.parse(e.target.result))
        const sortedData = that.sortJsonData(jsonData)
        that.googleJson = sortedData
      }
      reader.readAsText(file)
    },
    formatExtractedJsonIndex (index) {
      return index.replace(/_/g, ' ').replace(/-/g, ' ')
    },
    sortJsonData (jsonData) {
      const sortedData = {}
      const sortedKeys = Object.keys(jsonData).sort()
      sortedKeys.map(key => {
        sortedData[key] = jsonData[key]
      })
      return sortedData
    },
    setData (key, data) {
      this.configureForm[key] = data
      if (this.configureForm?.[key]?.enabled && !_.isEqual(this.originalCollector?.configure_security?.[key], data.data)) {
        this.configureForm[key].dirty = true
      } else {
        this.configureForm[key].dirty = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  #create-collector {
    .configure-security-wrapper {
      &.add-edit-wrapper {
        padding: 44px 40px !important;
      }
    }
  }
</style>

<style lang="scss">
  .google-security {
    .v-textarea {
      .v-input__slot {
        height: auto !important;
        .v-text-field__slot label{
          text-transform: capitalize;
        }
      }
    }
    .v-file-input {
      position: relative;
      &.error--text::after {
        bottom: 30px;
      }
      &::after {
        border-style: solid;
        border-width: thin 0 0 0;
        content: '';
        width: 100%;
        border-color: rgba(0, 0, 0, 0.42);
        position: absolute;
        bottom: 14px;
      }
    }
  }
</style>
